"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regions_unavailable_1 = require("@launchedla/hb-shared/dist/regions-unavailable");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_query_1 = require("react-query");
var fetch_user_geolocation_1 = require("../../utils/fetch-user-geolocation");
/** @param userCountryCode Uppercase country code that we believe the user is in. e.g. "US" or "CA" */
var isProductAvailableInRegion = function (productTags, userCountryCode) {
    var e_1, _a;
    var unavailableRegions = (0, regions_unavailable_1.getUnavailableRegions)(productTags) || [];
    try {
        for (var unavailableRegions_1 = __values(unavailableRegions), unavailableRegions_1_1 = unavailableRegions_1.next(); !unavailableRegions_1_1.done; unavailableRegions_1_1 = unavailableRegions_1.next()) {
            var region = unavailableRegions_1_1.value;
            if (userCountryCode === region.countryCode && !region.provinceCode)
                return false;
            // can add a check for an unavailable provinceCode here when needed
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (unavailableRegions_1_1 && !unavailableRegions_1_1.done && (_a = unavailableRegions_1.return)) _a.call(unavailableRegions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
var UnavailableInRegionDisclaimer = function (props) {
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie);
    // return null until the query is successful
    if (!userGeolocationQuery.isSuccess)
        return null;
    // return null if the product is available
    if (isProductAvailableInRegion(props.productTags, userGeolocationQuery.data.countryCode))
        return null;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex-container items-center justify-center', props.unavailableClassName) },
        props.iconUrl && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", { className: 'w-4', src: props.iconUrl, alt: 'Exclamation triangle icon' }),
            react_1.default.createElement("div", { className: 'margin-left-1' }))),
        react_1.default.createElement("div", { style: { marginTop: 3 } }, "This product is unavailable outside of the US.")));
};
exports.default = UnavailableInRegionDisclaimer;
